import { ReactNode } from 'react';

import { StatusDueDate } from '@/components/DueDate';
import Stack from '@/design_system/Stack';
import { ShipmentWithRelations } from '@/models/shipment';

export const ShipmentMessageTitle = ({
  children,
  shipment,
  showStatusDueAt = true,
}: {
  children: ReactNode;
  shipment: ShipmentWithRelations;
  showStatusDueAt?: boolean;
}) => {
  return (
    <Stack row gap="1rem" alignItems="center" flexWrap="nowrap">
      <div>{children}</div>
      {showStatusDueAt && shipment.statusDueAt && (
        <>
          <div
            style={{
              width: '1px',
              height: '16px',
              backgroundColor: 'var(--color-neutral-400)',
            }}
          />
          <StatusDueDate date={new Date(shipment.statusDueAt)} variant="row" />
        </>
      )}
    </Stack>
  );
};
